import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NotifierService } from "../ui";
import { Dossier } from "../dossier/dossier";
import { DossierModel } from "../dossier-model/dossier-model";
import { YearRange } from "./financial-data-report.component";

type ReportType = 'financial_data_default' | 'capitalisation_table';

interface Report {
  id: ReportType
  title: string
}


@Component({
  templateUrl: './report.component.html',
})
export class ReportComponent implements OnInit {

  title: string

  dossier: Dossier
  dossierModel: DossierModel

  fd_selectedRange: YearRange = null

  reports: Report[] = [
    {
      id: 'financial_data_default',
      title: 'Données financières'
    },
    {
      id: 'capitalisation_table',
      title: 'Table de capitalisation'
    }
  ];

  selectedReport: Report = this.reports[0]

  constructor(
    private route: ActivatedRoute,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.title = this.route.routeConfig.data.title;

    // Get the data
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.dossier = data.dossier;
      this.dossierModel = data.dossierModel;
    });
  }

  onSelect(report: Report) {
    this.selectedReport = report;
  }

  onFD_selectedRangeChanged(range: YearRange) {
    this.fd_selectedRange = range;
  }

  get canDownload():boolean {
    if(!this.selectedReport) {
      return false;
    }

    if(this.selectedReport.id === 'financial_data_default') {
      if(this.fd_selectedRange) {
        return true;
      }
    }

    if(this.selectedReport.id === 'capitalisation_table') {
      return true;
    }

    return false;
  }

  get downLoadLink(): string {
    if(!this.canDownload) {
      return null;
    }

    let link = null;

    if (this.selectedReport.id === 'financial_data_default') {
      link = `/files/reports/fd/default/${this.fd_selectedRange.link_1_id}/${this.fd_selectedRange.link_2_id}`;
    }
    else if (this.selectedReport.id === 'capitalisation_table') {
      link = `/files/capitalisation/${this.dossier.id}`;
    }

    return link;
  }

  get hasData(): boolean {
    if(!this.selectedReport) {
      return false;
    }

    if(this.selectedReport.id === 'capitalisation_table') {
      return false;
    }

    return true;
  }

}